<template>
  <div id="app">
    <Navbar />
    <transition name="router-animation">
      <router-view/>
    </transition>
  </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue'

export default {
  components:
  {
    Navbar
  }
}

</script>


<style>

@import "~bulma/css/bulma.css";

body
{
  font-size: 62.5%;
  font-family: 'GFS Didot', serif;
  letter-spacing: 0.0625em;
  margin: 0 auto;
}

#app 
{
  width: 100vw;
  height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0E0E0E;
}

a, a:hover
{
  color: #0E0E0E;
}

/*
*   Nav style
*/

.navbar 
{
  display: flex;
  width: 100vw;
  justify-content: space-between;
  position: fixed;
  z-index: 100;
  padding-top: 16px;
  padding-bottom: 16px;
}

.navbar-end 
{
  flex-direction: column;
  justify-content: flex-center;
  margin-left: 50px;
}

.navbar-end .item
{
  /* padding: 25px 30px; */
  transition:.5s;
  font-size: 2.4rem;
  display: flex;
  flex-direction: column;
}

.navbar, .navbar-menu
{
  background: #eeeeee;
  width: 100vw;
}

.navbar-menu
{
  display: none;
  height: 100vh;
}

.is-active
{
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: fixed;
  z-index: 10;
}

.navbar-item.is-tab:focus, .navbar-item.is-tab:hover {
  background-color: transparent;
  border-bottom-color: #eeeeee;
}

.navbar-brand
{
  display: flex;
  justify-content: flex-end;
}

.navbar-burger
{
  display: flex;
  position: fixed;
  color: #0E0E0E;
}

#home
{
  display: none;
}

.nav-left
{
  display: flex;
  justify-content: flex-start;
}

.navbar-end span
{
  color: #0E0E0E;
}

.navbar-end a 
{
  text-decoration: none;
  color: #0E0E0E;
}

.navbar-end a:hover 
{
  color: #0E0E0E;
}

.navbar-end a.router-link-exact-active 
{
  color: #f0838c;
}

.logo
{
  width: 75px;
  height: 75px;
}

.nav-logo
{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  top: 0;
  left: 0;
  margin-left: 50px;
  font-size: 2rem;
}

.page
{
  position: fixed;
  width: inherit;
}

/*
*   Project section
*/

.projects-section 
{
  display: flex;
  justify-content: center;
  padding: 3rem 0 20rem 0;
  will-change: transform;
}

.project-layout
{
  display: flex;
  align-items: center;
}

.project-img
{
  width: 50vw;
}

.project-category
{
  background: #eeeeee;
}

.project-category h1
{
  text-align: center;
  font-size: 3rem;
  padding: 6rem 0 1rem 0;
}

/* 
*   Animation betwenn pages
*/

.router-animation-enter-active
{
  animation: coming .5s;
  animation-delay: .7s;
  opacity: 0;
}

.router-animation-leave-active
{
  animation: going .5s;
}

@keyframes going
{
  from
  {
    transform: translateX(0px);
  }
  to 
  {
    transform: translateX(-50px);
    opacity: 0;
  }
}

@keyframes coming
{
  from
  {
    transform: translateX(-50px);
    opacity: 0;
  }
  to 
  {
    transform: translateX(0px);
    opacity: 1;
  }
}


/**

  RESPONSIVE

**/

@media screen and (max-width: 1024px) 
{
  .project-layout
  {
    display: block;
    margin-right: auto;
    margin-left: auto;
  }

  .project-img
  {
    width: 90vw;
  }

  /**
  
    NAVIGATION / HAMBURGER
  
  **/

  .nav-left
  {
    display: none;
  }

  .navbar 
  {
    position: fixed;
    flex-direction: column;
    width: 100vw;
    padding: 0px;
    font-size: 1rem;
    bottom: 0;
    transition: .5s;
  }

  #home
  {
    display: block;
  }

  .logo
  {
    display: none;
  }

  .navbar-menu.is-active
  {
    display: flex;
  }

  .navbar-end .item
  {
   font-size: 1rem;
   justify-content: center;
   transition: .5s;
  }

  .navbar-brand
  {
    margin-right: auto;
    margin-left: auto;
    transition: .5s;
  }

  .navbar-burger
  {
    margin-right: auto;
    margin-left: auto;
    transition: .5s;
    position: unset;
    color: #0E0E0E;
  }

  .is-active
  {
    transition: .5s;
  }
}
</style>
